<template>
<div class="chapter">
<div class="inner_page">
<p class="dedicationc"><a id="page_iii"><span class="small"><em class="italic">TO MY HUSBAND</em></span></a></p><a id="page_iii">
<p class="dedication">A fellow enthusiast for detective stories, and to whom I am indebted for much helpful advice and criticism</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?1adc7479